import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
export const get_category = createAsyncThunk(
  "product/get_category",
  async (_, { fulfillWithValue }) => {
    try {
      const { data } = await api.get("/home/get-categorys");
      return fulfillWithValue(data);
    } catch (error) {
      console.log(error.response);
    }
  }
);

export const get_speciality = createAsyncThunk(
  "product/get_speciality",
  async (_, { fulfillWithValue }) => {
    try {
      const { data } = await api.get("/home/get-specialties");
      return fulfillWithValue(data);
    } catch (error) {
      console.log(error.response);
    }
  }
);

export const get_products = createAsyncThunk(
  "product/get_products",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/home/get-products");

      // Ensure the products are filtered correctly on the client side if needed
      const filteredProducts = data.products.filter(
        (product) => product.isDeleted === "Disponible"
      );

      // Return filtered products and other data
      return {
        ...data,
        products: filteredProducts,
      };
    } catch (error) {
      console.error("Error fetching products:", error.message);
      return rejectWithValue(
        error.response?.data || "Failed to fetch products"
      );
    }
  }
);

export const get_products_Old = createAsyncThunk(
  "product/get_products",
  async (_, { fulfillWithValue }) => {
    try {
      const { data } = await api.get("/home/get-products");
      return fulfillWithValue(data);
    } catch (error) {
      console.log(error.response);
    }
  }
);

export const get_product = createAsyncThunk(
  "product/get_product",
  async (slug, { fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/home/get-product/${slug}`);
      //console.log(data);
      return fulfillWithValue(data);
    } catch (error) {
      console.log(error.response);
    }
  }
);

export const price_range_product = createAsyncThunk(
  "product/price_range_product",
  async (_, { fulfillWithValue }) => {
    try {
      const { data } = await api.get("/home/price-range-latest-product");
      return fulfillWithValue(data);
    } catch (error) {
      console.log(error.response);
    }
  }
);

// Get All Blogs
export const get_all_blogs = createAsyncThunk(
  "blog/get_all_blogs",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get("/get-all-blogs", {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const get_banners = createAsyncThunk(
  "product/get_banners",
  async (_, { fulfillWithValue }) => {
    try {
      const { data } = await api.get("/banners");
      return fulfillWithValue(data);
    } catch (error) {
      console.log(error.response);
    }
  }
);

export const query_products = createAsyncThunk(
  "product/query_products",
  async (query, { fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        `/home/query-products?category=${query.category}&&rating=${
          query.rating
        }&&lowPrice=${query.low}&&highPrice=${query.high}&&sortPrice=${
          query.sortPrice
        }&&pageNumber=${query.pageNumber}&&searchValue=${
          query.searchValue ? query.searchValue : ""
        }`
      );
      return fulfillWithValue(data);
    } catch (error) {
      console.log(error.response);
    }
  }
);

export const customer_review = createAsyncThunk(
  "review/customer_review",
  async (info, { fulfillWithValue }) => {
    try {
      const { data } = await api.post("/home/customer/submit-review", info);
      return fulfillWithValue(data);
    } catch (error) {}
  }
);

export const get_reviews = createAsyncThunk(
  "review/get_reviews",
  async ({ productId, pageNumber }, { fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        `/home/customer/get-reviews/${productId}?pageNo=${pageNumber}`
      );
      //console.log(data);
      return fulfillWithValue(data);
    } catch (error) {}
  }
);

export const get_active_doctors = createAsyncThunk(
  "doctor/get_active_doctors",
  async (_, { fulfillWithValue }) => {
    try {
      const { data } = await api.get("/home/get-active-doctors");
      return fulfillWithValue(data);
    } catch (error) {
      console.log(error.response);
    }
  }
);

export const get_active_seller_by_id = createAsyncThunk(
  "home/get_active_seller_by_id",
  async (sellerId, { fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/home/get-active-seller/${sellerId}`);

      return fulfillWithValue(data);
    } catch (error) {
      console.log(error.response);
    }
  }
);

export const homeReducer = createSlice({
  name: "home",
  initialState: {
    categorys: [],
    specialties: [],
    products: [],
    totalProduct: 0,
    parPage: 4,
    latest_product: [],
    topRated_product: [],
    discount_product: [],
    priceRange: {
      low: 0,
      high: 100,
    },
    product: {},
    relatedProducts: [],
    moreProducts: [],
    successMessage: "",
    errorMessage: "",
    totalReview: 0,
    rating_review: [],
    reviews: [],
    banners: [],
    doctors: [],
    activeSellerById: "",
    allBlogs: [],
  },
  reducers: {
    messageClear: (state, _) => {
      state.successMessage = "";
      state.errorMessage = "";
    },
  },
  extraReducers: {
    [get_category.fulfilled]: (state, { payload }) => {
      state.categorys = payload.categorys;
    },
    [get_speciality.fulfilled]: (state, { payload }) => {
      state.specialties = payload.specialties;
    },
    [get_products.fulfilled]: (state, { payload }) => {
      state.products = payload.products;
      state.latest_product = payload.latest_product;
      state.topRated_product = payload.topRated_product;
      state.discount_product = payload.discount_product;
    },
    [get_product.fulfilled]: (state, { payload }) => {
      state.product = payload.product;
      state.relatedProducts = payload.relatedProducts;
      state.moreProducts = payload.moreProducts;
    },
    [price_range_product.fulfilled]: (state, { payload }) => {
      state.latest_product = payload.latest_product;
      state.priceRange = payload.priceRange;
    },
    [query_products.fulfilled]: (state, { payload }) => {
      state.products = payload.products;
      state.totalProduct = payload.totalProduct;
      state.parPage = payload.parPage;
    },
    [get_all_blogs.fulfilled]: (state, { payload }) => {
      state.allBlogs = payload.allBlogs;
    },
    [customer_review.fulfilled]: (state, { payload }) => {
      state.successMessage = payload.message;
    },
    [get_reviews.fulfilled]: (state, { payload }) => {
      state.reviews = payload.reviews;
      state.totalReview = payload.totalReview;
      state.rating_review = payload.rating_review;
    },
    [get_banners.fulfilled]: (state, { payload }) => {
      state.banners = payload.banners;
    },
    [get_active_doctors.fulfilled]: (state, { payload }) => {
      state.doctors = payload.doctors;
    },
    [get_active_seller_by_id.fulfilled]: (state, { payload }) => {
      state.activeSellerById = payload.activeSellerById;
      state.successMessage = payload.message;
    },
    [get_active_seller_by_id.rejected]: (state, { payload }) => {
      state.errorMessage = payload.message;
    },
  },
});
export const { messageClear } = homeReducer.actions;
export default homeReducer.reducer;
